var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M14.023 0c-.511 0-1.012.199-1.398.585L6.01 7.176l-.146.146-.042.21-.46 2.336-.208.98.981-.209 2.338-.459.208-.041.146-.147 6.594-6.612c.277-.277.465-.63.541-1.013.076-.384.037-.781-.112-1.143-.15-.361-.403-.67-.728-.888C14.797.118 14.414 0 14.023 0zm0 1.294c.156 0 .31.08.46.23.297.297.297.62 0 .917l-6.47 6.467-1.148.23.23-1.147 6.47-6.467c.148-.148.302-.229.458-.229zM0 2.65V16h13.355V7.197L12.02 8.532v6.133H1.336V3.985H7.47L8.806 2.65H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a365c0e8e8f6ff34c59fac2a35d92621.svg";
export { ForwardRef as ReactComponent };